module.exports = __webpack_public_path__ + "img/fbqrcode.626419f4.jpg";